export default __webpack_public_path__ + "static/media/lightning.ed34bb4a.svg";